import React from "react";

const SoftwareIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 60"
    fill="#ffff"
    stroke="#ffff"
    {...props}
  >
    <path d="M59,0H1C0.4,0,0,0.4,0,1v46c0,0.6,0.4,1,1,1h4v11c0,0.6,0.4,1,1,1h48c0.6,0,1-0.4,1-1V48h4c0.6,0,1-0.4,1-1V1 
      C60,0.4,59.6,0,59,0z M58,2v6H2V2H58z M53,24H7v-6h46V24z M7,58V26h46v32H7z M55,46V17c0-0.6-0.4-1-1-1H6c-0.6,0-1,0.4-1,1v29H2 
      V10h56v36H55z"/>
    <rect x="4" y="4" width="4" height="2" />
    <rect x="10" y="4" width="4" height="2" />
    <rect x="9" y="20" width="4" height="2" />
    <rect x="15" y="20" width="4" height="2" />
    <rect x="54" y="4" width="2" height="2" />
    <rect x="50" y="4" width="2" height="2" />
    <rect x="49" y="20" width="2" height="2" />
    <rect x="45" y="20" width="2" height="2" />
    <path d="M11,47h16c0.6,0,1-0.4,1-1V30c0-0.6-0.4-1-1-1H11c-0.6,0-1,0.4-1,1v16C10,46.6,10.4,47,11,47z 
      M12,39h6v6h-6V39z M20,45v-6h6v6H20z M26,37h-6v-6h6V37z M18,31v6h-6v-6H18z"/>
    <rect x="31" y="29" width="4" height="2" />
    <rect x="31" y="33" width="2" height="2" />
    <rect x="35" y="33" width="2" height="2" />
    <rect x="39" y="33" width="2" height="2" />
    <rect x="43" y="33" width="2" height="2" />
    <rect x="47" y="33" width="2" height="2" />
    <rect x="38" y="29" width="4" height="2" />
    <rect x="45" y="29" width="4" height="2" />
    <rect x="31" y="37" width="18" height="2" />
    <rect x="31" y="41" width="18" height="2" />
    <rect x="31" y="45" width="18" height="2" />
    <rect x="10" y="51" width="2" height="2" />
    <rect x="14" y="51" width="2" height="2" />
    <rect x="18" y="51" width="2" height="2" />
    <rect x="22" y="51" width="27" height="2" />
  </svg>
);

export default SoftwareIcon;
